import api from './api';

// Admin side of the dashboard changelog (spec 2026-10-16 §3). The API answers
// 422 "User role / permission required" (plain string) unless the caller is
// role 100 or holds `releasenote-admin`.
const resource = 'ReleaseNoteAdmin/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + encodeURIComponent(id));
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const publish = async (id) => {
  return await api.post(resource + 'Publish', { id });
};

export const unpublish = async (id) => {
  return await api.post(resource + 'Unpublish', { id });
};

// JSON body `{ id }` — unlike imageLibraryAdminApi.deleteById, which sends a
// query string. Copying that file here would 400.
export const remove = async (id) => {
  return await api.post(resource + 'Delete', { id });
};

// `noteid` + `file` multipart. The note must already exist (media is stored
// under releasenotes/{noteid}/), so the editor saves a draft before the first
// upload. `purpose` is sent only when given: 'publisher-photo' stores the
// note's publisher photo (replacing any earlier one); block uploads send none,
// and the API refuses an unknown purpose.
export const uploadMedia = async (noteid, file, { purpose } = {}) => {
  const fd = new FormData();
  fd.append('noteid', noteid);
  fd.append('file', file);
  if (purpose) fd.append('purpose', purpose);
  return await api.post(resource + 'UploadMedia', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// The editor calls it for the publisher photo only (its Remove). Block media
// is never deleted from the editor: the server also deletes every block that
// referenced the media (spec §7.4).
export const deleteMedia = async (id) => {
  return await api.post(resource + 'DeleteMedia', { id });
};

const releaseNoteAdminApi = {
  list,
  getById,
  upsert,
  publish,
  unpublish,
  remove,
  uploadMedia,
  deleteMedia,
};

export default releaseNoteAdminApi;
